import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {TriggerUtils} from "@/modules/redactor/models/trigger/core/TriggerUtils";

export class AvatarModel extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._premium = false;
        this._priority = 0;

        this._triggersAvailable = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get premium() {
        return this._premium;
    }

    set premium(value) {
        this._premium = value;
    }

    get priority() {
        return this._priority;
    }

    set priority(value) {
        this._priority = value;
    }

    get triggersAvailable() {
        return this._triggersAvailable;
    }

    set triggersAvailable(value) {
        this._triggersAvailable = value;
    }

    valid() {

        if (!this.key || this.key.length <= 0) {
            return false;
        }

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (this.triggersAvailable.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._id = "";
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new AvatarModel());
        } else if (target instanceof AvatarModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(AvatarModel, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _premium: alias("premium", Schema.primitive()),
    _priority: alias("priority", Schema.primitive()),

    _triggersAvailable: alias("triggers_available", TriggerUtils.schema()),
});